const imgPath = '/img/product'

export const INTRODUCTION_IMG = `${imgPath}/introduction-lady.jpg`
export const INTRODUCTION_RIP_NEW = `${imgPath}/introduction-rip-new.svg`
export const GOOGLE_URL = 'https://www.google.com/search?q=back+market'
